import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/Modal/Modal';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';
import { DcrIntroModalContent } from '@/features/DataChangeRequest/DcrIntroModalContent/DcrIntroModalContent';
import { useBreakpoint } from '@/utils/useBreakpoint';

import { dcrControlStyles as sx } from './DcrControl.styles';

export const DcrControl = () => {
	const { t } = useTranslation();
	const isCollapsed = useBreakpoint('lg', 'down');
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);
	const [open, setOpen] = useState(false);

	const onOpen = () => setOpen(true);
	const onClose = () => setOpen(false);

	if (!dcrEnabled) {
		return null;
	}

	return (
		<>
			{!isCollapsed ? (
				<Button
					variant='contained'
					sx={sx.button}
					aria-label={t('REQUEST CHANGE')}
					onClick={onOpen}
					startIcon={<EditIcon />}
				>
					{t('REQUEST CHANGE')}
				</Button>
			) : (
				<IconButton
					sx={sx.button}
					aria-label={t('REQUEST CHANGE')}
					onClick={onOpen}
					color='primary'
				>
					<EditIcon fontSize='inherit' />
				</IconButton>
			)}

			<Modal
				open={open}
				onClose={onClose}
				size='sm'
				title={t('Requesting a change just got easier')}
				footer={
					<Button variant='contained' onClick={onClose}>
						{t('Try it')}
					</Button>
				}
			>
				<DcrIntroModalContent />
			</Modal>
		</>
	);
};
